module.exports = __webpack_public_path__ + "img/17.6e294a8d.webp";